export type LeadStatus = 'new' | 'contacted' | 'qualified' | 'proposal' | 'won' | 'lost'

export type ProjectType = 
  | 'virtual_production'
  | 'digital_humans'
  | 'ar_vr'
  | 'gaming'
  | 'medical'
  | 'research'
  | 'other'

export type BudgetRange = '<10k' | '10k-50k' | '50k-100k' | '100k+' | 'not_sure'

export type Timeline = 'immediate' | '1-3_months' | '3-6_months' | '6+_months' | 'exploring'

export interface Lead {
  id: number
  name: string
  email: string
  company?: string
  projectType: ProjectType
  budgetRange?: BudgetRange
  timeline: Timeline
  message: string
  status: LeadStatus
  source: string
  createdAt: string
  updatedAt: string
  interactions?: Interaction[]
}

export interface Interaction {
  id: number
  leadId: number
  type: string
  notes: string
  createdAt: string
}

export interface LeadListResponse {
  success: boolean
  data: Lead[]
  pagination: {
    page: number
    limit: number
    total: number
    totalPages: number
  }
}

export interface LeadDetailResponse {
  success: boolean
  data: Lead & {
    interactions: Interaction[]
  }
}

export interface LeadUpdateRequest {
  status: LeadStatus
  notes?: string
}

export const STATUS_LABELS: Record<LeadStatus, string> = {
  new: 'New',
  contacted: 'Contacted',
  qualified: 'Qualified',
  proposal: 'Proposal',
  won: 'Won',
  lost: 'Lost'
}

export const STATUS_COLORS: Record<LeadStatus, string> = {
  new: 'bg-blue-100 text-blue-800',
  contacted: 'bg-yellow-100 text-yellow-800',
  qualified: 'bg-purple-100 text-purple-800',
  proposal: 'bg-indigo-100 text-indigo-800',
  won: 'bg-green-100 text-green-800',
  lost: 'bg-red-100 text-red-800'
}

export const PROJECT_TYPE_LABELS: Record<ProjectType, string> = {
  virtual_production: 'Virtual Production',
  digital_humans: 'Digital Humans',
  ar_vr: 'AR/VR',
  gaming: 'Gaming',
  medical: 'Medical',
  research: 'Research',
  other: 'Other'
}

export const BUDGET_RANGE_LABELS: Record<BudgetRange, string> = {
  '<10k': 'Less than $10K',
  '10k-50k': '$10K - $50K',
  '50k-100k': '$50K - $100K',
  '100k+': 'More than $100K',
  'not_sure': 'Not Sure'
}

export const TIMELINE_LABELS: Record<Timeline, string> = {
  immediate: 'Immediate',
  '1-3_months': '1-3 Months',
  '3-6_months': '3-6 Months',
  '6+_months': '6+ Months',
  exploring: 'Just Exploring'
}